module.exports = __webpack_public_path__ + "static/media/site.aa4a3375.webmanifest";